import { reactive } from 'vue';

const casiState = reactive({
    isMatchingDay: false,
    isMatchingMonth: false,
    isMatchingYear: false,
});

export default casiState;